__turbopack_context__.v({
  "backLinkHeader": "backButton-module-scss-module__hco8IG__backLinkHeader",
  "backLinkMain": "backButton-module-scss-module__hco8IG__backLinkMain",
  "btn": "backButton-module-scss-module__hco8IG__btn",
  "btn-alt": "backButton-module-scss-module__hco8IG__btn-alt",
  "btn-default": "backButton-module-scss-module__hco8IG__btn-default",
  "btn-default-dark-bg": "backButton-module-scss-module__hco8IG__btn-default-dark-bg",
  "btn-disabled": "backButton-module-scss-module__hco8IG__btn-disabled",
  "btn-elite": "backButton-module-scss-module__hco8IG__btn-elite",
  "btn-gold": "backButton-module-scss-module__hco8IG__btn-gold",
  "btn-lg": "backButton-module-scss-module__hco8IG__btn-lg",
  "btn-link": "backButton-module-scss-module__hco8IG__btn-link",
  "btn-plat": "backButton-module-scss-module__hco8IG__btn-plat",
  "btn-primary": "backButton-module-scss-module__hco8IG__btn-primary",
  "btn-sm": "backButton-module-scss-module__hco8IG__btn-sm",
  "btn-success": "backButton-module-scss-module__hco8IG__btn-success",
  "btn-warning": "backButton-module-scss-module__hco8IG__btn-warning",
  "disabled": "backButton-module-scss-module__hco8IG__disabled",
  "eventRegistrationLink": "backButton-module-scss-module__hco8IG__eventRegistrationLink",
  "fullWidth": "backButton-module-scss-module__hco8IG__fullWidth",
  "lightLink": "backButton-module-scss-module__hco8IG__lightLink",
});
